import { createContext, useContext } from "react";

export type ClickShieldContext = {
  activate: () => void;
  deactivate: () => void;
};

export const ClickShieldContext = createContext<ClickShieldContext | undefined>(undefined);
ClickShieldContext.displayName = "ClickShieldContext";

export const useClickShield = () => {
  const context = useContext(ClickShieldContext);

  if (!context) {
    throw new Error(`Expected ClickShieldContext in ancestor tree.`);
  }

  return context;
};
